<template>
  <button class="mdn-btn">
    <slot />
  </button>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
.mdn-btn
  width: 100%
  max-width: 327px
  margin: 0 auto
  text-align: center
  display: block
  padding: 16px 32px
  cursor: pointer
  background: colors.$newred
  border-radius: 8px
  color: white
  font-size: 18px
  font-weight: 500
  line-height: 1.36
  box-shadow: 0px 24px 24px 0px rgba(242, 40, 87, 0.16)
  &:hover, &:active
    background: colors.$newRedHover
  &:disabled
    pointer-events: none
    background: colors.$moar_silver_for_the_god_of_silver2
    box-shadow: 0px 24px 24px 0px rgba(210, 212, 218, 0.16)
</style>